export default __webpack_public_path__ + "static/catch-81b4b7dd9497604d55eecbdec542d64d.png";